<template>
  <v-container fluid>
    <section>
      <!-- Summary Cards (4 Cards) -->
      <KpiCards class="mb-3" :items="kpiItems" :loading="loadingSummary" :skeleton="4" />

      <data-table
        :headers="headers"
        :items="category"
        commit="SET_CATEGORY"
        :viewItem="viewItem"
        :editItem="editItem"
        :deleteItem="deleteItem"
        :toggleEnableQrOrder="toggleEnableQrOrder"
        :toggleIsCooking="toggleIsCooking"
        :toggleBuffetIncluded="toggleBuffetIncluded"
      >
        <div slot="activator" class="row justify-content-between mb-4">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
            <v-card-title class="px-0 pt-0 ps-products-title">
              {{ $t("category") }}
            </v-card-title>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 offset-lg-5">
            <TextSearch
              v-model="search"
              @search="fetchItem()"
              @onClear="
                search = '';
                fetchItem();
              "
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 text-end">
            <v-btn
              depressed
              color="primary"
              class="white--text btn-primary-brand"
              @click="newItem"
            >
              <v-icon left small>fal fa-plus</v-icon>
              {{ $t("new_data") }}
            </v-btn>
          </div>
        </div>
      </data-table>

      <app-custom-dialog
        v-model="dialog"
        :footer="false"
        title="description"
        @submit="submitForm"
      >
        <div slot="activator">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="text-subtitle-1 font-weight-medium">
                {{ form.la_name }}
              </div>
              <div class="text-body-2 grey--text">
                {{ form.en_name || "-" }}
              </div>
            </v-col>

            <v-col cols="12" class="pt-0">
              <v-divider />
            </v-col>

            <v-col cols="4" class="grey--text">{{ $t("id") }}</v-col>
            <v-col cols="8" class="text-right font-weight-medium">{{
              form.id
            }}</v-col>

            <v-col cols="4" class="grey--text">{{ $t("name_th") }}</v-col>
            <v-col cols="8" class="text-right">{{ form.th_name || "-" }}</v-col>

            <v-col cols="4" class="grey--text">{{ $t("name_cn") }}</v-col>
            <v-col cols="8" class="text-right">{{ form.cn_name || "-" }}</v-col>

            <v-col cols="12" class="py-0">
              <v-divider />
            </v-col>

            <template v-if="store_type === 'POS'">
              <v-col cols="4" class="grey--text">{{ $t("online_order") }}</v-col>
              <v-col cols="8" class="text-right">
                <v-chip
                  small
                  label
                  dark
                  :color="form.is_online ? 'green' : 'red'"
                  class="text-capitalize"
                >
                  {{ form.is_online ? $t("yes") : $t("no") }}
                </v-chip>
              </v-col>
            </template>

            <template v-else>
              <v-col cols="4" class="grey--text">{{ $t("is_cook") }}</v-col>
              <v-col cols="8" class="text-right">
                <v-chip
                  small
                  label
                  dark
                  :color="form.is_cooking ? 'green' : 'red'"
                  class="text-capitalize"
                >
                  {{ form.is_cooking ? $t("yes") : $t("no") }}
                </v-chip>
              </v-col>
            </template>

            <template v-if="store_type === 'RESTAURANT' || store_type === 'BUFFET'">
              <v-col cols="4" class="grey--text">{{
                $t("enable_qr_order")
              }}</v-col>
              <v-col cols="8" class="text-right">
                <v-chip
                  small
                  label
                  dark
                  :color="form.enable_qr_order ? 'green' : 'red'"
                  class="text-capitalize"
                >
                  {{ form.enable_qr_order ? $t("yes") : $t("no") }}
                </v-chip>
              </v-col>
            </template>

            <template v-if="store_type === 'BUFFET'">
              <v-col cols="4" class="grey--text">{{
                $t("buffet_included_category")
              }}</v-col>
              <v-col cols="8" class="text-right">
                <v-chip
                  small
                  label
                  dark
                  :color="form.is_buffet_included ? 'green' : 'red'"
                  class="text-capitalize"
                >
                  {{ form.is_buffet_included ? $t("yes") : $t("no") }}
                </v-chip>
              </v-col>
            </template>

            <v-col cols="4" class="grey--text">{{ $t("sort_number") }}</v-col>
            <v-col cols="8" class="text-right font-weight-medium">{{ form.number || 0 }}</v-col>

            <v-col cols="4" class="grey--text">{{ $t("date") }}</v-col>
            <v-col cols="8" class="text-right">{{ form.created_at | moment }}</v-col>
          </v-row>
        </div>
      </app-custom-dialog>
      <app-custom-dialog
        v-model="dialogAdd"
        :footer="true"
        :title="titleStatus"
        :submit-text="update ? 'save' : 'add'"
        :submit-loading="submitting"
        @submit="submitForm"
      >
        <div slot="activator">
          <TTextField
            label="la_name"
            :errorMessages="nameError"
            v-model="form.la_name"
            @input="$v.form.la_name.$touch()"
            @blur="$v.form.la_name.$touch()"
          />
          <TTextField label="en_name" class="mt-3" v-model="form.en_name" />
          <TTextField label="name_th" class="mt-3" v-model="form.th_name" />
          <TTextField label="name_cn" class="mt-3" v-model="form.cn_name" />
          <TTextField label="sort_number" class="mt-3" v-model.number="form.number" type="number" :min="0" />
          <template v-if="store_type === 'POS'">
            <v-switch
              inset
              v-model="form.is_online"
              :label="$t('online_order')"
            ></v-switch>
          </template>
          <template v-else>
            <v-switch
              inset
              v-model="form.is_cooking"
              :label="$t('is_cook')"
            ></v-switch>
          </template>
          <template v-if="store_type === 'RESTAURANT' || store_type === 'BUFFET'">
            <v-switch
              inset
              v-model="form.enable_qr_order"
              :label="$t('enable_qr_order')"
            ></v-switch>
          </template>
          <template v-if="store_type === 'BUFFET'">
            <v-switch
              inset
              v-model="form.is_buffet_included"
              :label="$t('buffet_included_category')"
            ></v-switch>
          </template>
        </div>
      </app-custom-dialog>
      <!-- AppLoading -->
      <app-loading :overlay="overlay" />
    </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { productCategory } from "@/utils/head";
import TTextField from "@/components/global/TextField";
import { CategoryValidate } from "@/validations/shop";
import { success, confirm, toast } from "@/controllers/alert";
import { myMixin } from "@/mixin/main";

const defaultCategoryForm = () => ({
  la_name: "",
  en_name: "",
  th_name: "",
  cn_name: "",
  number: 0,
  is_online: 1,
  is_cooking: 1,
  enable_qr_order: 1,
  is_buffet_included: 0,
});

export default {
  mixins: [CategoryValidate, myMixin],
  data: () => ({
    update: false,
    dialogAdd: false,
    dialog: false,
    overlay: false,
    submitting: false,
    search: "",
    loadingSummary: true,
    summaries: [],

    form: defaultCategoryForm(),
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummary()]);
  },
  components: { DataTable, TTextField },
  computed: {
    kpiItems() {
      return (this.summaries || []).map((item, index) => ({
        key: index,
        title: item.title,
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
      }));
    },
    ...mapGetters({
      category: "index/category",
    }),

    titleStatus() {
      return this.update ? "update" : "new_data";
    },
    headers() {
      return productCategory(this);
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async toggleIsCooking(item, { desiredStatus }) {
      if (this.store_type === "POS") return;
      if (!item || !item.id) return;

      const prev = item.is_cooking;
      item.is_cooking = desiredStatus ? 1 : 0;

      const body = {
        la_name: item.la_name,
        en_name: item.en_name,
        th_name: item.th_name,
        cn_name: item.cn_name,
        is_online: item.is_online,
        is_cooking: item.is_cooking ? 1 : 0,
        enable_qr_order:
          this.store_type === "RESTAURANT" || this.store_type === "BUFFET"
            ? item.enable_qr_order
              ? 1
              : 0
            : undefined,
        is_buffet_included:
          this.store_type === "BUFFET"
            ? item.is_buffet_included
              ? 1
              : 0
            : undefined,
      };

      try {
        const { data } = await this.$http.put(`categories/${item.id}`, body);
        if (data?.status) {
          await toast(this, data?.message || "Updated", "success");
          return;
        }
        item.is_cooking = prev;
        await toast(this, data?.message || "error_occurred", "error");
      } catch (error) {
        item.is_cooking = prev;
        const message =
          error?.response?.data?.message ||
          error?.message ||
          this.$t("error_occurred") ||
          "Error";
        if (this.$toast) this.$toast.error(message);
      }
    },
    async toggleEnableQrOrder(item, { desiredStatus }) {
      if (this.store_type !== "RESTAURANT" && this.store_type !== "BUFFET")
        return;
      if (!item || !item.id) return;

      const prev = item.enable_qr_order;
      item.enable_qr_order = desiredStatus ? 1 : 0;

      const body = {
        la_name: item.la_name,
        en_name: item.en_name,
        th_name: item.th_name,
        cn_name: item.cn_name,
        is_online: item.is_online,
        is_cooking: item.is_cooking,
        enable_qr_order: item.enable_qr_order ? 1 : 0,
        is_buffet_included:
          this.store_type === "BUFFET"
            ? item.is_buffet_included
              ? 1
              : 0
            : undefined,
      };

      try {
        const { data } = await this.$http.put(`categories/${item.id}`, body);
        if (data?.status) {
          await toast(this, data?.message || "Updated", "success");
          return;
        }
        item.enable_qr_order = prev;
        await toast(this, data?.message || "error_occurred", "error");
      } catch (error) {
        item.enable_qr_order = prev;
        const message =
          error?.response?.data?.message ||
          error?.message ||
          this.$t("error_occurred") ||
          "Error";
        if (this.$toast) this.$toast.error(message);
      }
    },
    async toggleBuffetIncluded(item, { desiredStatus }) {
      if (this.store_type !== "BUFFET") return;
      if (!item || !item.id) return;

      const prev = item.is_buffet_included;
      item.is_buffet_included = desiredStatus ? 1 : 0;

      const body = {
        la_name: item.la_name,
        en_name: item.en_name,
        th_name: item.th_name,
        cn_name: item.cn_name,
        is_online: item.is_online,
        is_cooking: item.is_cooking ? 1 : 0,
        enable_qr_order: item.enable_qr_order ? 1 : 0,
        is_buffet_included: item.is_buffet_included ? 1 : 0,
      };

      try {
        const { data } = await this.$http.put(`categories/${item.id}`, body);
        if (data?.status) {
          await toast(this, data?.message || "Updated", "success");
          return;
        }
        item.is_buffet_included = prev;
        await toast(this, data?.message || "error_occurred", "error");
      } catch (error) {
        item.is_buffet_included = prev;
        const message =
          error?.response?.data?.message ||
          error?.message ||
          this.$t("error_occurred") ||
          "Error";
        if (this.$toast) this.$toast.error(message);
      }
    },
    async fetchItem() {
      const body = {
        that: this,
        url: `categories_paginate?q=${this.search}`,
        commit: "SET_CATEGORY",
      };
      await this.fetch(body);
    },

    async fetchSummary() {
      this.loadingSummary = true;
      try {
        const { data } = await this.$http.get("get_summary_categories");
        if (data && data.status) {
          this.summaries = data.data;
        }
      } catch (error) {
        console.log("error fetching category summary", error);
      } finally {
        this.loadingSummary = false;
      }
    },

    newItem() {
      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }
      this.form = defaultCategoryForm();
      if (this.store_type === "BUFFET") {
        this.form.is_buffet_included = 0;
      }
      this.update = false;
      this.dialogAdd = true;
    },

    editItem(item) {
      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }
      this.update = true;
      this.form = {
        ...defaultCategoryForm(),
        ...item,
        is_online: item.is_online ? 1 : 0,
        is_cooking: item.is_cooking ? 1 : 0,
        enable_qr_order:
          this.store_type === "RESTAURANT" || this.store_type === "BUFFET"
            ? item.enable_qr_order !== undefined && item.enable_qr_order !== null
              ? item.enable_qr_order
                ? 1
                : 0
              : 1
            : item.enable_qr_order,
        is_buffet_included:
          this.store_type === "BUFFET"
            ? item.is_buffet_included
              ? 1
              : 0
            : item.is_buffet_included,
      };
      this.dialogAdd = true;
    },
    async deleteItem({ id }) {
      const { isConfirmed } = await confirm({
        props: this,
        text: "want_to_delete",
      });
      if (isConfirmed) {
        try {
          const { data } = await this.$http.delete(`categories/${id}`);
          if (data && data.status) {
            await this.fetchItem();
            await this.fetchSummary();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        } catch (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            this.$t("error_occurred") ||
            "Error";
          if (this.$toast) {
            this.$toast.error(message);
          } else {
            await toast(this, message, "error");
          }
        }
      }
    },
    viewItem(item) {
      this.form = {
        ...defaultCategoryForm(),
        ...item,
      };
      if (
        (this.store_type === "RESTAURANT" || this.store_type === "BUFFET") &&
        (this.form.enable_qr_order === undefined || this.form.enable_qr_order === null)
      ) {
        this.form.enable_qr_order = 1;
      }
      if (
        this.store_type === "BUFFET" &&
        (this.form.is_buffet_included === undefined ||
          this.form.is_buffet_included === null)
      ) {
        this.form.is_buffet_included = 0;
      }
      this.dialog = true;
    },
    async submitForm() {
      try {
        this.$v.form.$touch();
        if (this.$v.form.$invalid) {
          return;
        }

        this.submitting = true;
        const body = {
          la_name: this.form.la_name,
          en_name: this.form.en_name,
          th_name: this.form.th_name,
          cn_name: this.form.cn_name,
          is_online: this.form.is_online ? 1 : 0,
          is_cooking: this.form.is_cooking ? 1 : 0,
          number: this.form.number || 0,
          enable_qr_order:
            this.store_type === "RESTAURANT" || this.store_type === "BUFFET"
              ? this.form.enable_qr_order
                ? 1
                : 0
              : undefined,
          is_buffet_included:
            this.store_type === "BUFFET"
              ? this.form.is_buffet_included
                ? 1
                : 0
              : undefined,
        };

        if (this.update) {
          const { data } = await this.$http.put(
            `categories/${this.form.id}`,
            body
          );
          if (data && data.status) {
            this.dialogAdd = false;
            await this.fetchItem();
            await this.fetchSummary();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        } else {
          const { data } = await this.$http.post("categories", body);
          if (data && data.status) {
            this.dialogAdd = false;
            await this.fetchItem();
            await this.fetchSummary();
            await success(this, data.message);
          } else {
            await toast(this, data?.message || "error_occurred", "error");
          }
        }
      } catch (error) {
        console.error("error submitting category", error);
        const message =
          error?.response?.data?.message ||
          error?.message ||
          this.$t("error_occurred") ||
          "Error";
        if (this.$toast) {
          this.$toast.error(message);
        } else {
          await toast(this, message, "error");
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
